// extracted by mini-css-extract-plugin
export default {"text":"CKnlm","link":"+OYYW","icon":"Jfuem","iconCheck":"f3nt0","iconPlus":"u+xvT","label":"_5nR5-"};